import {
	Accordion,
	EffectsIcon,
	EffectsIconLegacy as MainEffectsIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";

export function EffectsFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, facets } = useFiltersContext();
	const value = filters.effects ?? [];
	const facetCounts = facets?.effects;

	const getCount = (effect: string): number | undefined => {
		if (!facetCounts?.length) return undefined;
		return facetCounts.find((f) => f.value === effect)?.count ?? 0;
	};

	const sortedEffects = useMemo(() => {
		// @ts-ignore: dynamic key generation
		const translate = (key: string) => t(`filters.effects.${key}`) as string;
		return [...config.effects].sort((a, b) => {
			const translatedA = translate(a);
			const translatedB = translate(b);
			return translatedA.localeCompare(translatedB);
		});
	}, [config.effects, t]);

	return (
		<Accordion.Item
			value="effects"
			variant="filter"
			data-testid="effects-filter"
		>
			<Accordion.Trigger variant="filter" data-testid="effects-filter-trigger">
				<FilterHeader
					title={t("filters.effects")}
					value={Number(value?.length)}
					icon={<MainEffectsIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2"
					value={value}
					onValueChange={(val) => onFilterChange("effects", val)}
				>
					{sortedEffects.map((effect) => {
						/* @ts-ignore: dynamic key generation */
						const effectLabel = t(`filters.effects.${effect}`) as string;
						const normalizedEffect = effect
							.toLowerCase()
							.replace(/[\s_]/g, "-");
						const isSelected = value.includes(effect);
						const count = getCount(effect);
						const isDisabled = count === 0 && !isSelected;

						return (
							<ToggleGroup.Item
								key={effect}
								value={effect}
								className="capitalize"
								data-testid={`effect-${normalizedEffect}`}
								disabled={isDisabled}
							>
								<span className="mr-1.5 inline-flex">
									<EffectsIcon name={effect} size="sm" />
								</span>
								{effectLabel}
							</ToggleGroup.Item>
						);
					})}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
